 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		93: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"commons/d4183be4","1":"commons/0ee7e29f","2":"commons/49f6100e","3":"commons/934d51ca","6":"lang-en-US.js","7":"pages/administrators/managers","8":"pages/analytics_jobs/index","9":"pages/animation/campaigns","10":"pages/animation/index","11":"pages/animation/messages/emails","12":"pages/animation/messages/index","13":"pages/animation/messages/messages","14":"pages/animation/offers/bonus","15":"pages/animation/offers/grouped","16":"pages/animation/offers/index","17":"pages/animation/offers/refund","18":"pages/animation/quizzes","19":"pages/animation/stats_pushes","20":"pages/auth/login","21":"pages/auth/resetting_password","22":"pages/create-program","23":"pages/error/403","24":"pages/index","25":"pages/inspire","26":"pages/metrics/canals/general","27":"pages/metrics/canals/index","28":"pages/metrics/canals/onboarding_funnel","29":"pages/metrics/canals/points_of_sale","30":"pages/metrics/index","31":"pages/metrics/program/general","32":"pages/metrics/program/generosity","33":"pages/metrics/program/index","34":"pages/metrics/program/individual_behaviour","35":"pages/metrics/program/sales","36":"pages/metrics/program/usage","37":"pages/programs/contents","38":"pages/programs/index","39":"pages/programs/management/_programIdentifier/applet","40":"pages/programs/management/_programIdentifier/assets","41":"pages/programs/management/_programIdentifier/brands","42":"pages/programs/management/_programIdentifier/color","43":"pages/programs/management/_programIdentifier/descriptions","44":"pages/programs/management/_programIdentifier/index","45":"pages/programs/management/_programIdentifier/periods","46":"pages/programs/management/_programIdentifier/periods_new/_periodId/acquisitions","47":"pages/programs/management/_programIdentifier/periods_new/_periodId/explicit_mixity","48":"pages/programs/management/_programIdentifier/periods_new/_periodId/glances","49":"pages/programs/management/_programIdentifier/periods_new/_periodId/in_app_operation","50":"pages/programs/management/_programIdentifier/periods_new/_periodId/mixity","51":"pages/programs/management/_programIdentifier/periods_new/_periodId/purchases_by_region","52":"pages/programs/management/_programIdentifier/periods_new/_periodId/refunds","53":"pages/programs/management/_programIdentifier/periods_new/_periodId/retailer_share","54":"pages/programs/management/_programIdentifier/periods_new/_periodId/sales_details","55":"pages/programs/management/_programIdentifier/periods_new/_periodId/spendings_quantiles","56":"pages/programs/management/_programIdentifier/periods_new/_periodId/uplift_reports","57":"pages/programs/management/_programIdentifier/periods_new/_periodId/widget","58":"pages/programs/management/_programIdentifier/periods_new/index","59":"pages/programs/management/_programIdentifier/points","60":"pages/programs/management/_programIdentifier/precisions","61":"pages/programs/management/_programIdentifier/puzzle","62":"pages/programs/management/_programIdentifier/renewal_strategy","63":"pages/programs/management/_programIdentifier/stamps","64":"pages/programs/management/_programIdentifier/visibility","65":"pages/programs/management/index","66":"pages/programs/rules","67":"pages/select-program","68":"pages/sources/bars","69":"pages/sources/index","70":"pages/sources/points-of-sale","71":"pages/sources/products-collection","72":"pages/sources/products/denoms","73":"pages/sources/products/denoms-v2","74":"pages/sources/products/index","75":"pages/sources/products/tree","76":"pages/users/fraud","77":"pages/users/index","78":"pages/users/management/_userId/app/cards","79":"pages/users/management/_userId/app/coupons","80":"pages/users/management/_userId/app/index","81":"pages/users/management/_userId/app/misc","82":"pages/users/management/_userId/app/pot","83":"pages/users/management/_userId/app/timeline","84":"pages/users/management/_userId/bans/_banId","85":"pages/users/management/_userId/declarations/_declarationIdentifier","86":"pages/users/management/_userId/declarations/index","87":"pages/users/management/_userId/index","88":"pages/users/management/_userId/profile","89":"pages/users/management/_userId/timeline","90":"pages/users/management/index","91":"pages/users/segments","92":"pages/users/transfers"}[chunkId]||chunkId) + "." + {"0":"275ca7a","1":"9a18460","2":"476c232","3":"6b57fa1","6":"4cb731a","7":"85ab132","8":"afd6359","9":"00cb2c4","10":"82d256f","11":"ee89d3e","12":"c80c7ce","13":"289b99e","14":"bf5d38b","15":"6a995e2","16":"63ad342","17":"23b81eb","18":"e85ca49","19":"c4ecbf1","20":"82826ec","21":"2871545","22":"ba4233b","23":"5e73b39","24":"fe059d1","25":"73ee8b5","26":"3cd6102","27":"c233a7c","28":"c077c4a","29":"65cd674","30":"18569dc","31":"a2d911a","32":"1e9dd21","33":"50874b8","34":"ac50fce","35":"0ed1f75","36":"7bdc9fa","37":"35e4516","38":"ad3fb99","39":"e774648","40":"1a99224","41":"16b2bf8","42":"dcb809d","43":"dfa0833","44":"1c3ae9c","45":"06ab76e","46":"3dde9b7","47":"bea8093","48":"eebe3d9","49":"4a02364","50":"8ba97b0","51":"3a02b78","52":"b4bd781","53":"ff8b2de","54":"5be6c1b","55":"770c24b","56":"2fd8230","57":"2309c18","58":"7cdbb6b","59":"11bfc97","60":"5026b53","61":"d3ab130","62":"fd41957","63":"d88fcca","64":"4a677f9","65":"9c39329","66":"417d01a","67":"3b60b0b","68":"cd1c1e1","69":"55422d3","70":"9a02879","71":"918ac7d","72":"92ce0ca","73":"bec6373","74":"191d3ad","75":"a801434","76":"0aa1ac2","77":"f36e650","78":"0356a6c","79":"a9ea0f2","80":"cae4d98","81":"d978f09","82":"3c6930e","83":"cca24bf","84":"3f2c88d","85":"1e01e15","86":"08c177c","87":"bb43440","88":"9bb2e66","89":"47f80ce","90":"3a503c1","91":"b9ef7cb","92":"8190ef2","94":"35f251f","95":"6e62939"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/_nuxt/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
